export default {"src":"/_next/static/media/uk_flag.59042d34.svg","height":14,"width":18,"blurWidth":0,"blurHeight":0};